import React from 'react';
import styles from './usageCondition.module.scss';
import scene1 from '../../../assets/images/usageCondition_group_slipt.png'
import scene2 from '../../../assets/images/usageCondition_small_group_slipt.png'
import scene3 from '../../../assets/images/usageCondition_personal_debt.png'
import scene4 from '../../../assets/images/usageCondition_repayment.png'

const usageCondition = () => (
  <div className={[styles.container].join(' ')}>
    <div className={[styles.textBlock, 'col-12', 'text-center'].join(' ')}>
      <h3> 一次搞懂不同的花費情境 </h3>
    </div>
    <div className={styles.conditionBlock}>
      <div className={[styles.conditions, 'row'].join(' ')}>
        <div className={['col-6', 'col-sm-6', 'col-xl-3'].join(' ')}>
          <div className={styles.conditionTitle}>群組分帳</div>
          <img src={scene1} alt="龍寶寶使用情境一" />
          <p>旅途中公費支出 </p>
          <p>例：住宿費、交通費</p>
        </div>
        <div className={['col-6', 'col-sm-6', 'col-xl-3'].join(' ')}>
          <div className={styles.conditionTitle}>小組分帳</div>
          <img src={scene2} alt="龍寶寶使用情境二" />
          <p> 當非組內人員皆需付款之情形，例：5人中僅3人共乘計程車 </p>
        </div>
        <div className={['col-6', 'col-sm-6', 'col-xl-3'].join(' ')}>
          <div className={styles.conditionTitle}>私人帳款</div>
          <img src={scene3} alt="龍寶寶使用情境三" />
          <p> 臨時代墊支付</p>
          <p> 例：B幫Ａ付早餐錢 </p>
        </div>
        <div className={['col-6', 'col-sm-6', 'col-xl-3'].join(' ')}>
          <div className={styles.conditionTitle}>部分還款</div>
          <img src={scene4} alt="龍寶寶使用情境四" />
          <p> 非最後結清</p>
          <p> 只是先還部分費用 </p>
        </div>
      </div>
    </div>
  </div>
)

export default usageCondition;
